import { useEffect, useState } from 'react';

import { initFirebase, logError } from 'services/firebase';

const useApp = () => {
  const [wasInitialized, setWasInitialized] = useState(false);

  useEffect(() => {
    if (wasInitialized) return;

    initFirebase();
    setWasInitialized(true);
  }, [wasInitialized]);

  useEffect(() => {
    window.onerror = (message) => logError({ message });
    window.onunhandledrejection = (event) => logError(event.promise);
  }, []);

  return { wasInitialized };
};

export default useApp;
